import script from "./OnlineDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./OnlineDetail.vue?vue&type=script&setup=true&lang=js"

import "./OnlineDetail.vue?vue&type=style&index=0&id=60cba43b&lang=scss&scoped=true"
import "./OnlineDetail.vue?vue&type=style&index=1&id=60cba43b&lang=scss"
import "./OnlineDetail.vue?vue&type=style&index=2&id=60cba43b&lang=css"

import exportComponent from "K:\\宫俊勇\\青桔pc官网wf-qjgw\\wf-qjgw\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60cba43b"]])

export default __exports__